/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  DownloadPolicyPlugin,
  IDownloadPolicyPluginMethods,
  ErrorActualPlugin,
  IErrorActualPluginMethods,
  HeaderActualPlugin,
  IHeaderActualPluginMethods,
  LoadingActualPlugin,
  ILoadingActualPluginMethods,
  ActualListPlugin,
  IActualListPluginMethods,
  SettingsActualPlugin,
  ISettingsActualPluginMethods,
  StaticActualPagePlugin,
  IStaticActualPagePluginMethods,
} from './plugins';

export type TAgent = IDownloadPolicyPluginMethods &
  IErrorActualPluginMethods &
  IHeaderActualPluginMethods &
  ILoadingActualPluginMethods &
  IActualListPluginMethods &
  ISettingsActualPluginMethods &
  IStaticActualPagePluginMethods;

const getPlugins = () => {
  return [
    new StaticActualPagePlugin(),
    new ErrorActualPlugin(),
    new LoadingActualPlugin(),
    //Business logic plugins !
    new DownloadPolicyPlugin(),
    new HeaderActualPlugin(),
    new ActualListPlugin(),
    new SettingsActualPlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
